import { createEntityAdapter } from '@reduxjs/toolkit';
import { TournamentBracket } from '../../domain/interfaces/TournamentBracket';

const bracketsAdapter = createEntityAdapter<TournamentBracket>({
  selectId: (bracket) => bracket.id,
  sortComparer: (a, b) => a.rank - b.rank,
});

export default bracketsAdapter;
